import { render } from "./payback.vue?vue&type=template&id=ea7f7970&scoped=true"
import script from "./payback.vue?vue&type=script&lang=js"
export * from "./payback.vue?vue&type=script&lang=js"

import "./payback.vue?vue&type=style&index=0&id=ea7f7970&scoped=true&lang=css"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea7f7970"]])

export default __exports__